import React from 'react';
import Logger from '@ffw/logger-lib';

// Catches render-time errors (e.g. malformed API data reaching the DOM) and
// shows a friendly fallback instead of a raw crash/stack trace.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {hasError: false};
  }

  static getDerivedStateFromError() {
    return {hasError: true};
  }

  componentDidCatch(error, errorInfo) {
    Logger.error(error, "ErrorBoundary", {errorInfo});
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="wrapper">
          <div className="block block--s">
            <p>Something went wrong. Please refresh the page or try again later.</p>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
